import { Divider, Title } from '@huggg/react-components';
import classnames from 'classnames';
import { CoverImage, FooterContainer } from 'components';
import { CookieBanner as UICookieBanner, Menu as UIMenu } from 'components/ui';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { getCoverImageUrl, getBrandName } from 'utilities/huggg';
import styles from './default.module.scss';

export const LayoutsDefault = (props) => {
  const { children, className, huggg, menuItems, showDetails, title } = props;

  const coverImageUrl = useMemo(() => {
    return getCoverImageUrl(huggg);
  }, [huggg]);

  const coverImageAlt = useMemo(() => {
    return `${getBrandName(huggg)} Superhuggg CoverImage`;
  }, [huggg]);

  return (
    <div className={classnames(styles.layout, className)}>
      <UIMenu menuItems={menuItems} />

      <CoverImage
        className={styles.coverImage}
        imageUrl={coverImageUrl}
        alt={coverImageAlt}
      />

      {title && (
        <header className={styles.header}>
          <div className="container">
            <Title className={styles.title}>{title}</Title>
          </div>

          <Divider />
        </header>
      )}
      <main className="site-main">{children}</main>
      <FooterContainer
        className={styles.layoutFooter}
        showDetails={showDetails}
      />
      {(!huggg || !huggg.is_test) && <UICookieBanner />}
    </div>
  );
};

LayoutsDefault.defaultProps = {
  showDetails: true,
};

LayoutsDefault.propTypes = {
  huggg: PropTypes.object.isRequired,
  menuItems: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  showDetails: PropTypes.bool,
  title: PropTypes.any,
};

export default LayoutsDefault;
